import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function EyeOff({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>EyeOff</title>
      <path
        d="M4 4L20 20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.62658 5.68727C4.51191 6.91014 2.85274 8.83251 1.96504 11.1373C1.75124 11.6924 1.75124 12.3076 1.96504 12.8627C3.51626 16.8902 7.42322 19.75 12 19.75C14.4435 19.75 16.6961 18.9348 18.5012 17.5619L17.4292 16.4899C15.9042 17.5972 14.0281 18.25 12 18.25C8.06403 18.25 4.70047 15.7914 3.3648 12.3236C3.28465 12.1155 3.28465 11.8845 3.3648 11.6764C4.17801 9.56505 5.74294 7.82781 7.73109 6.79178L6.62658 5.68727ZM9.85968 8.92037C8.88672 9.59782 8.24997 10.7246 8.24997 12C8.24997 14.0711 9.9289 15.75 12 15.75C13.2754 15.75 14.4021 15.1132 15.0796 14.1403L13.9901 13.0507C13.6127 13.764 12.8631 14.25 12 14.25C10.7573 14.25 9.74997 13.2426 9.74997 12C9.74997 11.1369 10.236 10.3873 10.9492 10.0099L9.85968 8.92037ZM13.0941 10.0335L11.3643 8.30366C11.5709 8.26838 11.7833 8.25 12 8.25C14.071 8.25 15.75 9.92893 15.75 12C15.75 12.2167 15.7316 12.4291 15.6963 12.6357L13.9665 10.9059C13.7626 10.5402 13.4597 10.2374 13.0941 10.0335ZM18.5711 15.5104C19.463 14.6103 20.1713 13.5278 20.6351 12.3236C20.7153 12.1155 20.7153 11.8845 20.6351 11.6764C19.2995 8.20859 15.9359 5.75 12 5.75C11.0358 5.75 10.106 5.89753 9.23192 6.17129L8.05683 4.9962C9.2776 4.51461 10.6078 4.25 12 4.25C16.5767 4.25 20.4837 7.10981 22.0349 11.1373C22.2487 11.6924 22.2487 12.3076 22.0349 12.8627C21.4952 14.2639 20.6705 15.5237 19.6315 16.5709L18.5711 15.5104Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
